import Script from "next/script";

import { GOOGLE_TAG_MANAGER_ID } from "lib/constants";

export const GoogleConsent = () => {
  return (
    <script
      id="google-consent"
      data-cookieconsent="ignore"
      dangerouslySetInnerHTML={{
        __html: `
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments)
      }
      gtag("consent", "default", {
        ad_personalization: "denied",
        ad_storage: "denied",
        ad_user_data: "denied",
        analytics_storage: "denied",
        functionality_storage: "denied",
        personalization_storage: "denied",
        security_storage: "granted",
        wait_for_update: 500
      });
      gtag("set", "ads_data_redaction", true);
      gtag("set", "url_passthrough", true);
      `,
      }}
    />
  );
};

export const TagManager = () => (
  <Script
    id="google-tag-manager"
    strategy="afterInteractive"
    data-cookieconsent="ignore"
    dangerouslySetInnerHTML={{
      __html: `
      function checkCookieValue(cookieName, expectedValue) {
         if (document.cookie.split(';').filter(function (item) {
            return item.indexOf(cookieName + '=' + expectedValue) >= 0
         }).length) {
            return true;
         }
         return false;
      }
      function isSiftedRegistered(){
         return /^(.*;)?\\s*sifted_registered\\s*=/.test(document.cookie);
      }
      function isNewsletterVisited(){
        const cookieNewsletterVisit = /^(.*;)?\\s*sifted_newsletter_visit\\s*=/.test(document.cookie);
        if (cookieNewsletterVisit) return true;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const newsLetterVisitedParam = urlParams.get("utm_source") === "siFTed";
        if (newsLetterVisitedParam === true){
          document.cookie = "sifted_newsletter_visit=true; path=/; max-age=15768000"; //15768000 = 6 months
          return true;
        }
        return false;
      }

      function getMembershipLevel(){
        if (checkCookieValue("sMemLev","mem")) {
          return "Member";
        } else if (checkCookieValue("sMemLev","startup")) {
          return "Startup";
        } else if (checkCookieValue("sMemLev","angel")) {
          return "Angel";
        } else if (checkCookieValue("sMemLev","pro")) {
          return "Pro";
        } else if (checkCookieValue("sMemLev","reg")) {
          return "Registered";
        }
        return "Anonymous";
      }

      window.sifted_member_level = getMembershipLevel();

      if (isSiftedRegistered() || isNewsletterVisited()){
        window.sifted_newsletter_user = true;
      }

      window.sifted_version = "2.5-headless";

      (function(w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
        });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';
        j.async = true;
        j.src =
          'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, 'script', 'dataLayer', '${GOOGLE_TAG_MANAGER_ID}');
      `,
    }}
  />
);
